import { MainMenu, pages, sub } from "@/core/config/MainMenuType";
import CleanMainMenuConfig from "@/core/config/CleanMainMenuConfig";
const findSub = (val) => {
  if (val.children.length > 0) {
    const childrens = val.children;
    const sub: Array<pages> | Array<sub> = [];
    for (let i = 0; i < childrens.length; i++) {
      if (childrens[i].children.length > 0) {
        sub.push({
          sectionTitle: childrens[i].cTenChucNang,
          route: childrens[i].cUrl ? val[i].cUrl : "/404",
          fontIcon: childrens[i].cIcon ? childrens[i].cIcon : "",
          sub: findSub(childrens[i]),
        });
      } else {
        sub.push({
          heading: childrens[i].cTenChucNang,
          route: childrens[i].cUrl ? childrens[i].cUrl : "/404",
          fontIcon: childrens[i].cIcon ? childrens[i].cIcon : "",
          sub: [],
        });
      }
    }
    return sub;
  } else {
    return [];
  }
};
export const formatUserMenu = (val, userTypeId) => {
  const userMenuConfig: Array<MainMenu> = JSON.parse(
    JSON.stringify(CleanMainMenuConfig)
  );
  if (val.length == 0) {
    return userMenuConfig;
  }
  const pages: Array<pages> = [];
  for (let i = 0; i < val.length; i++) {
    if (val[i].children.length > 0) {
      pages.push({
        sectionTitle: val[i].cTenChucNang,
        route: val[i].cUrl ? val[i].cUrl : "/404",
        fontIcon: val[i].cIcon ? val[i].cIcon : "",
        sub: findSub(val[i]),
      });
    } else {
      pages.push({
        heading: val[i].cTenChucNang,
        route: val[i].cUrl ? val[i].cUrl : "/404",
        fontIcon: val[i].cIcon ? val[i].cIcon : "",
        sub: [],
      });
    }
  }
  userMenuConfig.push({
    heading: "",
    pages: pages,
    route: "",
  });
  return userMenuConfig;
};

export const componentSize = () => {
  if (window.innerWidth < 450) {
    return "small";
  } else {
    return "default";
  }
};
